import "./index.css";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { Page } from "@/components/Page";
import type { ITabsItem } from "@/ui-kit";
import { Tabs } from "@/ui-kit";
import { useCallback, useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { ROUTES } from "@/router";

const Settings = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const url = pathname.split("/");

  const activeTab = useMemo(() => {
    if (url.includes(ROUTES.SETTINGS_PASSWORD)) {
      return ROUTES.SETTINGS_PASSWORD;
    }

    return ROUTES.SETTINGS_PROFILE;
  }, [url]);

  const items: ITabsItem[] = useMemo(() => {
    const defaultTabs: ITabsItem[] = [
      {
        id: ROUTES.SETTINGS_PROFILE,
        text: t("label.profile"),
      },
      {
        id: ROUTES.SETTINGS_PASSWORD,
        text: t("label.password"),
      },
    ];
    return defaultTabs;
  }, [t]);

  const onTabChange = useCallback(
    (id: string) => {
      navigate(id);
    },
    [navigate],
  );

  return (
    <Page className="settings-page">
      <PageHeader title={t("label.settings")} />
      <Tabs items={items} onChange={onTabChange} activeItem={activeTab} />
      <div className="setting-tab-content">
        <Outlet />
      </div>
    </Page>
  );
};

export default Settings;
